import React from 'react';

import { NotFound, PageTitle, PublicBackground } from '@app/core';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';

import { Route, Routes, useParams } from 'react-router-dom';
import { useParticipation } from '@app/api';
import { ParticipationSummaryIndex } from './ParticipationSummaryIndex';
import { ParticipantCancelConfirmation } from './ParticipantCancelConfirmation';
import { ParticipantCancel } from './ParticipantCancel';
import { ParticipantReschedule } from './ParticipantReschedule';
import { ParticipantBooking } from './ParticipantBooking';
import { LoginParticipantContextProvider } from '@app/auth';
import { useTranslation } from 'react-i18next';

export const ParticipationSummary = () => {
  const { id: idOrRef } = useParams();
  const { t } = useTranslation();
  const { data: participation, isLoading } = useParticipation(idOrRef);
  if (!idOrRef) {
    return null;
  }

  if (isLoading) {
    return <PublicBackground isLoading={isLoading} />;
  }
  if (!participation) {
    return <NotFound />;
  }

  return (
    <AnalyticsCategoryProvider category={Categories.PARTICIPATION_SUMMARY}>
      <LoginParticipantContextProvider>
        <PageTitle title={t('booked.metaTitle')} />
        <Routes>
          <Route path="booking/*" element={<ParticipantBooking />} />
          <Route path="reschedule" element={<ParticipantReschedule />} />
          <Route path="cancel" element={<ParticipantCancel />} />
          <Route
            path="cancel/confirm"
            element={<ParticipantCancelConfirmation />}
          />
          <Route path="abandon" element={<ParticipantCancel />} />
          <Route
            path="abandon/confirm"
            element={<ParticipantCancelConfirmation isAbandoned />}
          />
          <Route path="*" element={<ParticipationSummaryIndex />} />
        </Routes>
      </LoginParticipantContextProvider>
    </AnalyticsCategoryProvider>
  );
};
